import * as React from "react";
const SvgQueuePositionMarker = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 8.4666665 8.4666666", id: "svg1", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("defs", { id: "defs1" }), /* @__PURE__ */ React.createElement("g", { id: "layer1" }, /* @__PURE__ */ React.createElement("circle", { style: {
  opacity: 1,
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 0.39969808,
  strokeLinecap: "round",
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path7", cx: 4.2333331, cy: 4.2333331, r: 0.78363812, transform: "matrix(2.9788109,0,0,2.9788109,-8.3769658,-8.3769658)" })), /* @__PURE__ */ React.createElement("g", { id: "layer2", style: {
  display: "none"
} }, /* @__PURE__ */ React.createElement("circle", { style: {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeDasharray: "none",
  strokeOpacity: 0.186094
}, id: "path4", cx: 4.2333331, cy: 4.2333331, r: 1.2884716 }), /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeDasharray: "none",
  strokeOpacity: 0.147239
}, d: "M 0,0 4.2333333,4.2333333", id: "path5" })));
export { SvgQueuePositionMarker as ReactComponent };
